/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "keyhole-875ebb26--sprite",
  "use": "keyhole-875ebb26--sprite-usage",
  "viewBox": "0 0 36.021 36.021",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36.021 36.021\" id=\"keyhole-875ebb26--sprite\"><g opacity=\"0\"><path d=\"M124.433,220.444a18.011,18.011,0,1,1-18.011,18.011h0A18.011,18.011,0,0,1,124.433,220.444Z\" transform=\"translate(-106.422 -220.444)\" fill=\"#fcf8d0\" /></g><path d=\"M136.319,242.343a8,8,0,1,0,8,8A8,8,0,0,0,136.319,242.343ZM137.737,251a.508.508,0,0,0-.245.569l.729,2.885a.517.517,0,0,1-.5.64h-2.805a.514.514,0,0,1-.5-.64l.725-2.885a.506.506,0,0,0-.24-.569,2.885,2.885,0,1,1,2.836,0Z\" transform=\"translate(-118.296 -232.322)\" fill=\"currentColor\" /></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
